import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UnifiedService } from '../unified.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
    selector: 'app-integration-callback',
    templateUrl: './integration-callback.component.html',
    styleUrls: ['./integration-callback.component.scss'],
    standalone: false
})
export class IntegrationCallbackComponent implements OnInit {

  state: { unified_integration_id: number, user_id: number };
  isCallbackComplete: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private unifiedService: UnifiedService, private localstorageService: LocalStorageService, private router: Router) { }

  ngOnInit() {
    const userid = this.localstorageService.getItem('userid');
    this.activatedRoute.queryParams.subscribe(params => {
      this.isCallbackComplete = true;
      if ('state' in params && 'id' in params && params.state && params.id) {
        // decode the state (it's base64url encoded)
        this.state = JSON.parse(atob(params.state));
        const connection_id = params.id;
        if (this.state.unified_integration_id && this.state.user_id === parseInt(userid)) {
          this.unifiedService.enableUnifiedIntegration(this.state.unified_integration_id, connection_id).subscribe(response => {
            if (response.status === 'success') {
              setTimeout(() => {
                this.router.navigate(['/settings/ats-integrations'], { fragment: 'connected', replaceUrl: true });
              }, 1000);
            }
          }, (error) => {
            console.error(error);
            setTimeout(() => {
              this.router.navigate(['/settings/ats-integrations'], { fragment: 'error', replaceUrl: true });
            }, 1000);
          });
        }
      } else {
        this.router.navigate(['/settings/ats-integrations'], { replaceUrl: true });
      }
    });
  }

}
